import { render, staticRenderFns } from "./PartDetail.vue?vue&type=template&id=e3b2a418"
import script from "./PartDetail.vue?vue&type=script&lang=ts"
export * from "./PartDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports